import styled from "styled-components";
import { Form } from "formik";

import colors from "@src/common/styles/colors";
import { DEFAULT_MARGIN_M, DEFAULT_MARGIN_S } from "@src/common/styles/const";
import { defaultLetterSpacing, media } from "@src/common/styles/mixins";

export const ResultsFormWrapper = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: ${DEFAULT_MARGIN_M}px;
`;

export const ResultDescription = styled.p`
  white-space: pre-line;
  font-size: 14px;

  ${media.down("MOBILE")`
    font-size:12px;
  `}
`;

export const ResultsTable = styled.table`
  font-size: 12px;
  width: 100%;
`;

export const ResultsTableHeader = styled.th`
  ${defaultLetterSpacing};
  text-transform: uppercase;
  text-align: right;
  font-weight: 400;
  white-space: nowrap;
  color: ${colors.almostBlack};

  ${media.down("MOBILE")`
    padding-left: 10px;
  `};
`;

export const ResultsTableRow = styled.tr`
  height: 32px;
`;

export const ResultLabelTooltipWrapper = styled.div`
  display: flex;
  gap: ${DEFAULT_MARGIN_S}px;
`;
